import { Action, createReducer, on } from '@ngrx/store';
import {
  Account,
  AccountDomainSetting,
  Dictionary,
  Section,
} from '../../models';
import {
  accountDomainSettingActions,
  getAccountsActions,
  getSectionsActions,
  sectionDomainActions,
} from '../actions/domain-settings-edit.actions';

export interface State {
  accounts?: Account[];
  sections?: Dictionary<Section>;
  accountDomainSetting?: AccountDomainSetting;
}

export const initialState: State = {
  accounts: [],
};

const domainSettingsEditReducer = createReducer(
  initialState,
  on(getAccountsActions.success, (state, { accounts }) => ({
    ...state,
    accounts,
  })),
  on(getSectionsActions.success, (state, { sections }) => ({
    ...state,
    sections,
  })),
  on(accountDomainSettingActions.clear, (state) => ({
    ...state,
    accountDomainSetting: undefined,
    sections: undefined,
  })),
  on(accountDomainSettingActions.setAccountSuccess, (state, { accountId }) => ({
    ...state,
    accountDomainSetting: {
      accountId,
    },
  })),
  on(accountDomainSettingActions.toggleDomain, (state, { enabled }) => ({
    ...state,
    accountDomainSetting: {
      ...state.accountDomainSetting,
      enabled,
    },
  })),
  on(
    accountDomainSettingActions.setAccountDomainName,
    (state, { accountDomainName }) => ({
      ...state,
      accountDomainSetting: {
        ...state.accountDomainSetting,
        domainNames: {
          ...state.accountDomainSetting?.domainNames,
          accountDomain: accountDomainName,
        },
      },
    }),
  ),
  on(
    accountDomainSettingActions.addAccountDomainSetting,
    (state, { accountDomainSetting }) => ({
      ...state,
      accountDomainSetting,
    }),
  ),
  on(sectionDomainActions.addSectionDomain, (state, { section }) => ({
    ...state,
    accountDomainSetting: {
      ...state.accountDomainSetting,
      domainNames: {
        ...state.accountDomainSetting.domainNames,
        sections: [
          ...((state.accountDomainSetting.domainNames &&
            state.accountDomainSetting.domainNames.sections) ||
            []),
          {
            id: section.id,
            name: section.name,
            domainName: section.domainName,
          },
        ],
      },
    },
  })),
  on(sectionDomainActions.removeSectionDomain, (state, { sectionId }) => ({
    ...state,
    accountDomainSetting: {
      ...state.accountDomainSetting,
      domainNames: {
        ...state.accountDomainSetting.domainNames,
        sections: state.accountDomainSetting.domainNames.sections.filter(
          (section) => section.id !== sectionId,
        ),
      },
    },
  })),
  on(
    sectionDomainActions.selectSectionDomainSuccess,
    (state, { sectionId }) => ({
      ...state,
      accountDomainSetting: {
        ...state.accountDomainSetting,
        domainNames: {
          ...state.accountDomainSetting.domainNames,
          sections: state.accountDomainSetting.domainNames.sections.map(
            (section) =>
              section.id === sectionId
                ? { ...section, selected: true }
                : { ...section, selected: false },
          ),
        },
      },
    }),
  ),
);

export const reducer = (state: State | undefined, action: Action) =>
  domainSettingsEditReducer(state, action);

export const getAccounts = (state: State) => state.accounts;
export const getSections = (state: State) => state.sections;
export const getSelectedAccountDomainSetting = (state: State) =>
  state.accountDomainSetting;
export const getSelectedAccountDomainName = (state: State) =>
  state.accountDomainSetting?.domainNames?.accountDomain;
export const getSelectedAccountId = (state: State) =>
  state.accountDomainSetting?.accountId;
export const getSelectedAccountToggle = (state: State) =>
  state.accountDomainSetting?.enabled;
export const getSelectedSectionsDomains = (state: State) =>
  state.accountDomainSetting?.domainNames?.sections;
